export default __webpack_public_path__ + "static/media/calendar.67a4e272.svg";